import { GetManagementUserAccountLicenseDto } from './../../../api/gen/api';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  private activeLicense: GetManagementUserAccountLicenseDto | null = null;

  constructor() {
    const storedLicense = localStorage.getItem('activeLicense');
    if (storedLicense) {
      const parsed = JSON.parse(storedLicense);
      const now = new Date().getTime();

      // Check if the license is still valid (within 12 hours)
      if (parsed.timestamp && now - parsed.timestamp < 12 * 60 * 60 * 1000) {
        this.activeLicense = parsed.license;
      } else {
        localStorage.removeItem('activeLicense');
      }
    }
  }

  removeActiveLicense() {
    this.activeLicense = null;
    localStorage.removeItem('activeLicense');
  }

  setActiveLicense(license: GetManagementUserAccountLicenseDto) {
    this.activeLicense = license;

    // Store license with timestamp
    const dataToStore = {
      license,
      timestamp: new Date().getTime(),
    };

    localStorage.setItem('activeLicense', JSON.stringify(dataToStore));
  }

  getActiveLicense(): GetManagementUserAccountLicenseDto | null {
    return this.activeLicense;
  }
}
